import { ComponentProps, FC } from "react";
import { StatusIndicator } from "../../Components/StatusIndicator/StatusIndicator";
import { getProductStatusConfig } from "../../Utils/getProductStatusConfig";

type Props = {
  productData: {
    status: {
      statusText: string;
      statusCode: string;
    };
  } | null;
  theme?: ComponentProps<typeof StatusIndicator>["theme"];
};

/** Maps the BC product status to its configured display label and color. */
export const ProductStatus: FC<Props> = ({ productData, theme = "full" }) => {
  if (!productData?.status?.statusCode || !productData?.status?.statusText) {
    return <></>;
  }

  const { status } = productData;

  const statusConfig = getProductStatusConfig(status);

  return (
    <StatusIndicator
      label={statusConfig.textOverride}
      color={statusConfig.color}
      title={`${status.statusText} (${status.statusCode})`}
      theme={theme}
    />
  );
};
